import { defineComponent as _defineComponent } from 'vue'
import type { ICoursePreview, ISpeaker } from "@/types/entities/ICoursePreview";
import { computed } from "vue";

interface Props {
  previewData: ICoursePreview;
}
interface Emits {
  (e: "onReadMore"): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CourseFacultyPanel',
  props: {
    previewData: {}
  },
  emits: ["onReadMore"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emits = __emit;

const sortedSpeakers = computed<ISpeaker[]>(() => {
  const modules = props.previewData.speakers ?? [];
  return [...modules].sort((a, b) => a.sort_order - b.sort_order);
});

const __returned__ = { props, emits, sortedSpeakers, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})